import React from 'react';

function Heading({text}) {
    return (
        <div className="heading" data-aos="fade-right" data-aos-delay="100">
            <div className="heading__text">
                {text}
            </div>
        </div>
    )
}

export default Heading;
